import React, { Profiler } from "react";
import { AppShellDesktop } from "../components/elements/AppShell";
import { Helmet } from "react-helmet-async";
import useClientMetrics from "../hooks/useClientMetrics";
import Container from "../components/elements/Container";
import styles from "./Confirmation.desktop.module.css";
import CheckoutAlternativeFaresDesktopInner from "../components/elements/CheckoutAlternativeFares/CheckoutAlternativeFaresInner.desktop";

const CheckoutAlternativeFaresDesktop = () => {
  const { trackRenderTime } = useClientMetrics();

  return (
    <Profiler id="screen" onRender={trackRenderTime}>
      <Helmet />
      <AppShellDesktop className={styles.appShell} noMainWrapper>
        <Container pr={4} pl={4}>
          <CheckoutAlternativeFaresDesktopInner />
        </Container>
      </AppShellDesktop>
    </Profiler>
  );
};

export default CheckoutAlternativeFaresDesktop;
